export default __webpack_public_path__ + "static/media/duplicate_icon.2563431a.svg";